import { render } from "./ChangeAccountEmailWithToken.vue?vue&type=template&id=c04c2c0e"
import script from "./ChangeAccountEmailWithToken.vue?vue&type=script&lang=js"
export * from "./ChangeAccountEmailWithToken.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__